/* KC native pre-order (Pinnacle theme): keeps the button label, ETA bar and line-item property in sync on variant change. */
(function () {
  var LABEL = 'Pre Order';

  function state(sectionId) {
    var el = document.getElementById('Preorder-' + sectionId);
    if (!el) return null;
    var map = {};
    try { map = JSON.parse(el.querySelector('.kc-preorder__map').textContent); } catch (e) {}
    return { el: el, map: map };
  }

  function applyButtons(on) {
    document.querySelectorAll('.single-add-to-cart-button').forEach(function (btn) {
      var s = btn.querySelector('.single-add-to-cart-button--text');
      if (!s) return;
      btn.dataset.kcPreorder = on ? '1' : '';
      if (on && !btn.hasAttribute('disabled')) {
        if (s.textContent !== LABEL) { btn.dataset.kcOrig = s.textContent; s.textContent = LABEL; }
        btn.classList.add('btn--preorder');
      } else if (!on && s.textContent === LABEL) {
        s.textContent = btn.dataset.kcOrig || s.textContent;
        btn.classList.remove('btn--preorder');
      }
    });
  }

  function update(sectionId, variantId) {
    var st = state(sectionId); if (!st) return;
    var eta = variantId ? (st.map[String(variantId)] || '') : st.el.dataset.eta;
    var on = !!eta;
    st.el.dataset.preorder = on ? 'true' : 'false';
    st.el.dataset.eta = eta;
    st.el.classList.toggle('hidden', !on);
    var inp = st.el.querySelector('input[name="properties[Pre-order]"]');
    if (inp) { inp.value = eta; inp.disabled = !on; }
    var notice = st.el.querySelector('.kc-preorder__notice');
    if (notice) { notice.textContent = eta; notice.hidden = !on; }
    applyButtons(on);
    // the theme re-labels the button asynchronously after its section fetch; re-apply a few times
    [50, 300, 800, 1500].forEach(function (t) { setTimeout(function () { applyButtons(on); }, t); });
  }

  // Guard: whenever the theme rewrites the label while pre-order is on, put it back.
  function observe() {
    document.querySelectorAll('.single-add-to-cart-button--text').forEach(function (s) {
      new MutationObserver(function () {
        var btn = s.closest('button');
        if (btn && btn.dataset.kcPreorder === '1' && !btn.hasAttribute('disabled') && s.textContent !== LABEL && !btn.classList.contains('loading')) {
          s.textContent = LABEL;
        }
      }).observe(s, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    document.querySelectorAll('.kc-preorder').forEach(function (el) { update(el.id.replace('Preorder-', ''), null); });
    observe();
    document.addEventListener('product:variant-change', function (ev) {
      var d = ev.detail || {};
      if (d.sectionId) update(d.sectionId, d.variant ? d.variant.id : null);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
